<template>
  <div class="point-result-container">
    <svg-icon :name="getIconUrl(info)" class="poi-icon" />
    <div :class="{ 'is-active': isActive }" class="point-result-content">
      <p class="title overflow-management" v-html="info.unifiedTitle"></p>
      <p class="address overflow-management" v-html="info.unifiedAddress"></p>
    </div>
  </div>
</template>
<script>
import { iconInDifferentPoint } from '@/config/map-icons'
export default {
  props: {
    info: {
      typeof: Object,
      default: () => {}
    },
    isActive: {
      typeof: Boolean,
      default: false
    }
  },
  methods: {
    // 获取poi的icon
    getIconUrl(point) {
      return iconInDifferentPoint(point).listIcon
    },
  }
}
</script>
<style lang="scss" scoped>
.point-result-container {
  padding: 10px;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  border-bottom: 1px solid #F5F7FA;
  border-radius: 4px;
  &:hover {
    background-color: #F5F7FA;
  }
  .poi-icon {
    margin-right: 10px;
    flex-shrink: 0;
    font-size: 20px;
  }
  .point-result-content {
    flex: 1;
    overflow: hidden;
    &.is-active {
      .title, .address {
        color: #4066d4 !important;
      }
    }
    .title {
      font-family: OpenSans;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      color: #000000;
      ::v-deep b {
        font-family: OpenSans;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #4066d4;
      }
    }
    .address {
      margin-top: 2px;
      font-family: OpenSans;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #7F8596;
      ::v-deep b {
        font-family: OpenSans;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #4066d4;
      }
    }
  }
}
</style>
